<template>
    <v-card
        rounded="normal"
    >
        <div class="d-flex align-center justify-space-between ga-4 pa-6 flex-wrap">
            <div class="d-flex align-center justify-space-between ga-2 flex-grow-1">
                <div class="d-flex flex-column font-italic">
                    <v-skeleton-loader type="list-item-two-line" width="150" class="ml-n4 my-n1 "
                                       :loading="product.price_no_vat === 'loading...'">
                        <div class="pl-4">
                            <price-hider big>
                                <div v-if="(product.discount_additional_voc && product.discount_additional_voc !== 0)
                                            || (product.discount_base && product.discount_base !== 0)"
                                     class="text-tiny-link text-red-darken-2" v-html="additionalSale"></div>
                                <price-positioner>
                                    <template #with_vat="{ active }">
                                        <div v-if="product.your_sale && !$page.props.customer?.email" class="d-flex ga-2 align-end mb-1">
                                            <div class="text-body-2 font-italic text-decoration-line-through">{{ product.price_no_discount_with_vat }}</div>
                                            <div class="text-small border-red rounded-ts-md rounded-be-md px-2 text-red" v-html="yourSale"></div>
                                        </div>
                                        <div :class="[active ? 'text-h5 font-weight-black':'text-body-2 text-grey', product.your_sale ?'text-red':'']" v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_with_vat', { price: product.price })"></div>
                                    </template>
                                    <template #without_vat="{ active }">
                                        <div :class="active ? 'text-h5 font-weight-black':'text-body-2 text-grey'" v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_no_vat', { price: product.price_no_vat })"></div>
                                    </template>
                                </price-positioner>
                            </price-hider>
                        </div>
                    </v-skeleton-loader>
                </div>
                <quantity-changer
                    :model-value="toAdd" :stock="onStock" allow-no-stock
                    @update:model-value="emit('update:modelValue', $event)"
                    style="min-width: 140px"
                    :size="56"
                ></quantity-changer>
            </div>
            <div class="d-flex align-center align-self-stretch ga-4" :class="{'w-100': $vuetify.display.smAndDown}">
                <v-btn
                    class="px-8 text-body-1 align-self-stretch w-auto"
                    color="green-lighten-1"
                    size="56"
                    elevation="0"
                    rounded="true"
                    :loading="loading"
                    @click="emit('addToOrder')"
                    :block="$vuetify.display.smAndDown"
                >
                    <v-icon left :icon="mdiCartPlus" class="mr-2"/>
                    {{ $t('eshop::product-details.insert_into') }}
                </v-btn>
            </div>
        </div>
        <price-hider moc v-if="$page.props.customer?.email">
            <v-divider></v-divider>
            <div class="d-flex px-6 py-4 align-start flex-column ga-0">
                <template v-if="!product.your_sale">
                    <div class="text-body-2 font-italic">{{ $t('eshop::product-details.retail_price') }}</div>
                    <div class="text-body-1 font-italic font-weight-bold">{{ product.moc_price }}
                        {{ $t('eshop::product-details.with_vat') }}
                    </div>
                    <div class="text-body-2 text-grey font-italic">{{ product.moc_price_without_vat }}
                        {{ $t('eshop::product-details.without_vat') }}
                    </div>
                </template>
                <template v-else>
                    <div class="text-body-2 font-italic">{{ $t('eshop::product-details.retail_price') }}</div>
                    <div class="d-flex ga-2 align-center">

                        <div class="text-body-2 font-italic text-decoration-line-through">{{ product.price_no_discount_with_vat }}</div>
                        <div class="text-body-1 text-red font-italic font-weight-bold">{{ product.moc_price }}
                            {{ $t('eshop::product-details.with_vat') }}
                        </div>
                        <div class="text-small border-red rounded-ts-md rounded-be-md px-2 text-red" v-html="yourSale"></div>
                    </div>
                    <div class="text-body-2 text-grey font-italic">{{ product.moc_price_without_vat }}
                        {{ $t('eshop::product-details.without_vat') }}
                    </div>
                </template>
<!--                <div v-else class="text-body-2 text-grey font-italic">
                    {{ $t('eshop::product-details.retail_with_vat') }}: {{ product.moc_price }}
                </div>-->
            </div>
        </price-hider>
    </v-card>
</template>

<script setup>
import {computed} from "vue";
import QuantityChanger from "./QuantityChanger.vue";
import {mdiCartPlus} from "@mdi/js";
import {trans} from "laravel-vue-i18n";
import PriceHider from "./PriceHider.vue";
import PricePositioner from "./PricePositioner.vue";

const props = defineProps({
    product: Object,
    toAdd: Number,
    onStock: Number,
    loading: Boolean
})

const emit = defineEmits(['update:modelValue', 'addToOrder']);
const noVat = computed(() => `${props.product.price} s DPH`);
const additionalSale = computed(() => {
    const percentage_base = new Intl.NumberFormat('default', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(props.product?.discount_base)

    const percentage_additional = props.product?.discount_additional_voc ? new Intl.NumberFormat('default', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(props.product?.discount_additional_voc) : null

    return trans('eshop::product-details.additional_sale') + `: <span class="font-weight-bold">${percentage_base}</span>` + (percentage_additional ? `<span class="font-weight-bold"> + ${percentage_additional}</span>`:'')
})

const yourSale = computed(() => {
    const percentage = new Intl.NumberFormat('default', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(props.product.your_sale)

    return trans('eshop::product-details.your_sale') + `: <span class="font-weight-bold">${percentage}</span>`
})
</script>

<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'vuetify/lib/styles/settings/colors' as *;
@use 'sass:map';

.v-card {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.10) !important;
}
.border-red {
    border: 1px solid map.get($red, base);
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
